import React from 'react';

const HoursContext = React.createContext({
    hours: { negative: 0, positive: 0, total: 0 },
    setHours: () => { }
})

export default HoursContext;